/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbComponentStatus, NbGlobalPhysicalPosition, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbToastrService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserStore } from '../../../@core/stores/user.store';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../insurgo-services/user.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  siteName = environment.siteName;
  siteNameSmall = environment.siteNameSmall;
  headerLogo = environment.headerLogo.length > 0 ? "assets/images/" + environment.headerLogo : '';

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = this.getMenuItems();

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userStore: UserStore,
    private userService: UserService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private toastrService: NbToastrService) {
  }

  getMenuItems() {
    const userLink = this.user ? '/profile' : '';
    return [
      { title: 'Profile', link: userLink },
      { title: 'Log out', link: '/auth/logout' },
      { title: 'Toggle Tour'},
    ];
  }

  async toggleGuide() {
    let newValue = 0;
    if (this.user.showGuide === 0) newValue = 1;
    try {
      await this.userService.toggleGuide(newValue).toPromise();
      this.user.showGuide = newValue;
      this.userStore.setUser(this.user);
      this.showToast("success", "Update", `Tour preference updated, if you wish to see the tour on your current page please refresh or navigate away and back`, 'activity');
    } catch (error) {
      console.log(error);
      this.showToast("warning", "Error", `Unable to update tour preference`, 'activity');
 
    }
  }



  async ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    try {
      this.user = await this.userStore.getUser();
      
    } catch (error) {
      console.log(error);
         }
    this.userMenu = this.getMenuItems();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick().subscribe((event) => {
      if (event.item.title === 'Toggle Tour') {
        this.toggleGuide();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName)
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  private showToast(type: NbComponentStatus, title: string, body: string, iconName: string = 'alert-triangle-outline') {
    const config = {
      status: type,
      destroyByClick: false,
      duration: 4000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: true,
      icon: iconName,
      pack: 'eva'
    };

    this.toastrService.show(
      body,
      title,
      config
    );
  }
}
